package com.dotdrives.controller
import com.dotdrives.core.DotController
import com.dotdrives.model.*
import com.dotdrives.repository.DashboardRepository
import kotlinx.coroutines.*
import kotlin.time.Clock
import kotlin.time.Instant
data class DashboardUiState(val loading:Boolean=false,val snapshot:DashboardSnapshot?=null,val queue:List<DashboardQueueItem> = emptyList(),val pendingId:String?=null,val error:String?=null)
class DashboardController(private val repo:DashboardRepository,scope:CoroutineScope,private val orgId:String,private val canFinance:Boolean,private val now:()->Instant={Clock.System.now()},private val canWrite:Boolean=canFinance):DotController<DashboardUiState>(DashboardUiState(),scope) {
 private var job:Job?=null;private var generation=0
 fun load() {
  job?.cancel();val request=++generation;val asOf=now();update {it.copy(loading=true,error=null)}
  job=scope.launch { try {
   val (snapshot,queue)=coroutineScope {
    val snapshot=async { repo.snapshot(orgId,asOf).getOrThrow() }
    val queue=async { repo.queue(orgId,asOf).getOrThrow() }
    snapshot.await() to queue.await()
   }
   if(request==generation)update {it.copy(loading=false,snapshot=if(canFinance)snapshot else snapshot.copy(finance=null,unthankedCount=null),queue=rankDashboardQueue(queue.filter { (canFinance||it.kind!="gift")&&dashboardItemDue(it,asOf) }),error=null)}
  } catch(e:Throwable){if(e is CancellationException)throw e;if(request==generation)update {it.copy(loading=false,error=e.message?:"Unable to load dashboard")}} }
 }
 fun complete(item:DashboardQueueItem) {
  if((item.kind=="gift"&&!canFinance) || (item.kind=="reminder"&&!canWrite) || item.kind !in setOf("gift","reminder") || state.value.pendingId!=null)return
  update {it.copy(pendingId=item.id,error=null)}
  scope.launch {try {
   (if(item.kind=="gift")repo.acknowledge(orgId,item.id) else repo.completeReminder(orgId,item.id)).getOrThrow()
   update {it.copy(pendingId=null)};load()
  }catch(e:Throwable){if(e is CancellationException)throw e;update {it.copy(pendingId=null,error=e.message?:"Unable to save. Try again.")}}}
 }
}
